// axios
import axios from "axios";
import store from "./store/store";
import router from "./router";
import baseUrl from "./util/backend";

const instance = axios.create();

instance.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    let originalRequest = error.config;
    if (error.response) {
      if (
        error.response.status === 400 &&
        error.response.data.message == "Invalid token"
      ) {
        store.dispatch("logout");
        router.replace({ name: "page-login" });
      }
      if (
        error.response.status === 401 &&
        error.response.data.message == "Permission"
      ) {
        alert("Not an ADMIN");
        store.dispatch("logout");
        router.replace({ name: "page-login" });
      }
      if (
        error.response.status === 401 &&
        error.response.data.message == "jwt expired" &&
        !originalRequest._retry
      ) {
        // ยิง Refresh token เพื่อเอา Access Token ใหม่
        originalRequest._retry = true;
        try {
          const response = await axios.post(`${baseUrl()}user/refreshtoken`, {
            refresh_token: store.state.refreshToken,
            id_user: store.state.user_id,
          });
          originalRequest.headers["Authorization"] =
            "Bearer " + response.data.token;
          return axios.request(originalRequest);
        } catch (err) {
          router.replace({ name: "page-login" });
          store.dispatch("logout");
          return Promise.reject(err);
        }
      }
    } else {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default instance;
